import { Image } from "antd";
import React from "react";
import styled from "styled-components";

import { useScreen } from "../../../hooks/useScreen";

const StyledLogoImage = styled(Image)`
  margin-top: 10px;
`;

const StyledSmallLogoImage = styled(Image)`
  margin-top: 10px;
  margin-left: -20px;
`;

export const P0NavIcon: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const { isDesktop } = useScreen();
  const useSmall = collapsed || !isDesktop;
  return useSmall ? (
    <StyledSmallLogoImage
      preview={false}
      src="/p0-small-logomark-dark.svg"
      alt="P0"
      width={40}
      height={30}
      style={collapsed ? { marginLeft: 0 } : undefined}
    />
  ) : (
    <StyledLogoImage
      preview={false}
      src="/p0-logomark-dark.svg"
      alt="P0"
      width={160}
    />
  );
};
